import { createStore } from "vuex";
import axios from "axios";

export const store = createStore({
  state: {
    token: localStorage.getItem("accessToken") || "",
    successMessage: "",
    status: "",
    search: "",
    isLoading: true,
    shareBaseUrl: "web.idlc.com/share/",
    storyShareBaseUrl: "web.idlc.com/story/share/",
    csrShareBaseUrl: "web.idlc.com/csr/share/",
    favourite: [],
    favouriteRouteTitle: []
  },
  getters: {
    serach: state => {
      return state.search;
    }
  },

  mutations: {
    auth_success(state, token) {
      state.status = "success";
      state.token = token;
    },
    updateSearch: (state, payload) => {
      state.search = payload;
    },
    dataAdded() {}
  },

  actions: {
    submitContactForm({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("contact-us", payload)
          .then(res => {
            commit("dataAdded");
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },

    submitComplaint({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("post-feedback-complaint", payload)
          .then(res => {
            commit("dataAdded");
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },

    submitForHomeLoan({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("apply-loan", payload)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },
    updateSearch({ commit }, payload) {
      commit("updateSearch", payload);
    },
    submitAppliedResumeForm({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("applied-resume", payload)
          .then(res => {
            commit("dataAdded");
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },

    submitDepositForm({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("post-dps", payload)
          .then(res => {
            commit("dataAdded");
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },
    submitForSME({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("sme-loan-applied", payload)
          .then(res => {
            commit("dataAdded");
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },

    submitAfterEligibilityChecked({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("post-home-loan-eligible", payload)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },

    investorInformationSubmit({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("investor-relation-form", payload)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },
    async leadSubmission({ commit }, payload) {
      try {
        const token = await fetch(
          "https://apps.idlc.com/ExternalReferralAppApi/api/Auth/login",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              username: "IdlcReferralApp",
              password: "Idlc@03Ref#app@25"
            })
          }
        )
          .then(res => res.json())
          .then(res => res.Data.Token);

        if (!token) {
          throw new Error("Failed to retrieve token");
        }

        const response = await fetch(
          "https://apps.idlc.com/ExternalReferralAppAPI/api/Referral/create/referral",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(payload)
          }
        ).then(res => res.text());

        return response;
      } catch (error) {
        console.error("leadSubmission error:", error);
        throw error;
      }
    }
  },

  modules: {}
});
